// const baseUrl = "http://localhost:443";
const baseUrl = "https://dev.api.sourcecoders.io/";
const clientSubscribeUrl = baseUrl + "mailchimp/bd/subscribe";
const clientUnsubscribeUrl = baseUrl + "mailchimp/bd/unsubscribe";
const getCurrentCandidatePipelineUrl = baseUrl + "bd/tp";
const candidateSubscribeUrl = baseUrl + "mailchimp/candidates/subscribe";
const candidateUnsubscribeUrl = baseUrl + "mailchimp/candidates/unsubscribe";

export const apiPostClientSignup = async (request: { email: String; interests:{}}) => {
	
	const data = {
		email: request.email,
		interests: request.interests
	};

	const response = await fetch(clientSubscribeUrl, {
		method: 'POST',
		mode: 'cors',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	});

	let jsonResponse = await response.json();

	return jsonResponse;
}


export const apiPostClientUnsubscribe = async (request: {email: String;}) => {
	const data = {
		email: request.email
	};

	const response = await fetch(clientUnsubscribeUrl, {
		method: 'POST',
		mode: 'cors',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	});

	let jsonResponse = await response.json();

	return jsonResponse;
}

export const apiGetCurrentCandidatePipeline = async () => {
	const response = await fetch(getCurrentCandidatePipelineUrl, {
		method: 'GET',
		mode: 'cors'
	});

	let jsonResponse = await response.json();

	return jsonResponse;
}

export const apiPostCandidateSignup = async (request: { email: String; interests:{}}) => {
	
	const data = {
		email: request.email,
		interests: request.interests
	};

	const response = await fetch(candidateSubscribeUrl, {
		method: 'POST',
		mode: 'cors',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	});

	let jsonResponse = await response.json();

	return jsonResponse;
}


export const apiPostCandidateUnsubscribe = async (request: {email: String;}) => {
	const data = {
		email: request.email
	};

	const response = await fetch(candidateUnsubscribeUrl, {
		method: 'POST',
		mode: 'cors',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	});

	let jsonResponse = await response.json();

	return jsonResponse;
}